import React from "react";

function RegistrationHeader({ language }) {
  const t = {
    EN: {
      title: "Registration Form",
      subtitle: "Please complete the form to register.",
    },
    ES: {
      title: "Formulario de Registro",
      subtitle: "Por favor completá el formulario para registrarte.",
    },
  };

  return (
    <>
      <img
        src="/img/banner-event.png"
        alt="Econojournal Energy Day 2025"
        className="bannerEvent"
      />
      <img
        src="/img/banner-event-mobile.png"
        alt="Econojournal Energy Day 2025"
        className="bannerEventMobile"
      />

      <h2>{t[language].title}</h2>
      <h3>{t[language].subtitle}</h3>
    </>
  );
}

export default RegistrationHeader;